import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const StaticPage = ({ title, accent, eyebrow, children, testid }) => (
  <div className="min-h-screen bg-paper-light">
    <Header />
    <main data-testid={testid} className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-[32px] font-bold text-ink">{title}{accent && <> <span className="text-gold">{accent}</span></>}</h1>
      {eyebrow && <p className="mt-2 text-[13px] tracking-[0.15em] uppercase text-[#9ca3af]">{eyebrow}</p>}
      {children}
    </main>
    <Footer />
  </div>
);
